module.exports = __webpack_public_path__ + "img/KSC05996.86e9048c.jpg";